const DefaultDashboard = () => {
    return (
        <h1>Default Componente</h1>
      );
}
 
export default DefaultDashboard;